// Implements: F-IDN-012
/**
 * P2: the two writes of the public recovery pages. Neither touches the session cache: the request
 * answers the same for any address, and the confirmation sets no cookie (it closed every session
 * of that person), so the person signs in afresh with the new password.
 */

import { useMutation } from "@tanstack/react-query";
import type { UseMutationResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { confirmPasswordReset, requestPasswordReset } from "../api/authApi";

export interface ResetConfirmation {
  readonly token: string;
  readonly newPassword: string;
}

export function useRequestPasswordReset(): UseMutationResult<unknown, ApiError, string> {
  return useMutation<unknown, ApiError, string>({ mutationFn: requestPasswordReset });
}

export function useConfirmPasswordReset(): UseMutationResult<unknown, ApiError, ResetConfirmation> {
  return useMutation<unknown, ApiError, ResetConfirmation>({
    mutationFn: ({ token, newPassword }) => confirmPasswordReset(token, newPassword),
  });
}
